<template>
  <!-- 房产信息 -->
  <div class="item" >
    <div class="line" v-if="item.label"> 
      <div class="label">{{item.label}}：</div>
      <div class="value">{{renderTxt(itemKey,item.values)}}</div>
      <nd-button class="change" @click="visible=true" v-if="itemKey || itemKey===0">我要修改</nd-button>
    </div>
    <div class="radios-container" v-show="visible ||  !(typeof(itemKey)==='number')">
      <div :class="['r-item',{active:itemKey===i.value}]" v-for="i in item.values" :key="i.value" @click="setValue(item,i)">{{i.displayName}}</div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    itemKey: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    renderTxt (key, values) {
      if (key || key === 0) {
        return values.find(item => item.value === key).displayName
      }
    },
    setValue ({ key }, { value }) {
      console.log(key, value)
      this.$emit('on-set', { key, value })
      this.visible = false
    } 
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";


  .item {
    display: flex;
    flex-direction: column;
    .line {
      display: flex;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      padding:20px 40px;
      &:before {
        content: '*';
        font-weight: 500;
        color: #DC5050;
      }
      .value {
        flex:1
      }
      .change {
        width: 140px;
        height: 48px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        border-radius: 28px;
        font-size: 24px;
      }
    }

    .radios-container{
      display: flex;
      flex-wrap:wrap;
      padding-left:40px;
      .r-item {
        width: 320px;
        height: 72px;
        border-radius: 8px;
        border: 1px solid #FF4633;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF4633;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        margin-right: 30px;
        margin-bottom: 20px;
        padding:2px 20px;
        line-height: 28px;
        &.active {
          background: #FF4633;
          color: #fff;
        }
      }
    }

    .input-container {
      .input-item {
        padding:20px 40px;
        &:before {
          content: '*';
          font-weight: 500;
          color: #DC5050;
        }
        .label {
          display: inline;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .input-detail {
          width: 670px;
          height: 72px;
          border-radius: 8px;
          border: 1px solid #AAAAAA;
          margin-top: 20px;
          /deep/ .nd-input {
            input{
            padding: 18px  20px;
          }
          } 
        }
      }
    }
  }
</style>